<div class="dialog-content">
  <div style="color: #c43f3f" [innerHTML]="config.data.message" class="dialog-content__msg"></div>
</div>

<div class="footer">
  <button class="footer__btn footer__btn--reject" (click)="reject()">{{ config.data.label }}</button>
</div>
